import React, { Component } from 'react';
import { DataTable as DataTableComponent } from 'legion-ui';

const dataTable = [
  {
    fullName: 'Eric Clapton',
    born: 'Ripley, United Kingdom',
    age: 77,
  },
  {
    fullName: 'Adam Sandler',
    born: 'Brooklyn, New York, United States',
    age: 56,
  },
  {
    fullName: 'Jennifer Aniston',
    born: 'Sherman Oaks, Los Angeles, California, United States',
    age: 53,
  },
  {
    fullName: 'Ben Stiller',
    born: 'New York, New York, United States',
    age: 56,
  },
  {
    fullName: 'Brooklyn Decker',
    born: 'Dayton, Ohio, United States',
    age: 35,
  },
];

class App extends Component {
  state = {
    valueTable: dataTable,
    search: '',
    category: '',
  };

  _handleSearch = (e) => {
    this.setState({ search: e.target.value }, () => {
      setTimeout(() => {
        this._handleSearchDoc();
      }, 1000);
    });
  };

  _handleCategory = (e) => {
    this.setState({ category: e.target.value });
  };

  _handleNestedTable = (val) => {
    return (
      <tr>
        <td colSpan={5} style={{ border: '1px solid grey' }}>
          Child dari index ke - {val}
        </td>
      </tr>
    );
  };

  _handleSearchDoc = () => {
    const { search, category } = this.state;

    let searchDoc = dataTable.filter((val) => {
      if (category === '' || category === 'Fullname') {
        return val.fullName.toString().toLowerCase().includes(search.toLowerCase());
      } else if (category === 'Born') {
        return val.born.toString().toLowerCase().includes(search.toLowerCase());
      } else {
        return val.age.toString().toLowerCase().includes(search.toLowerCase());
      }
    });
    this.setState({ valueTable: searchDoc });
  };

  _handleSortUp = (val) => {};

  render() {
    return (
      <React.Fragment>
        <DataTableComponent
          headers={{
            id: 'Fullname',
            name: 'Born',
            count: 'Age',
          }}
          items={this.state.valueTable}
          onFilterCategory={this._handleCategory}
          onSortUp={this._handleSortUp}
          onSearch={this._handleSearch}
          onNestedTable={this._handleNestedTable}
          search={this.state.search}
        />
      </React.Fragment>
    );
  }
}

export default App;
